import React, { useState } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { MEDIA_URL } from '../../config/constants';

const ContactSection = () => {
  const { t } = useTranslation('about');
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, submitted: false, error: null });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(process.env.REACT_APP_API_KEY && { "X-API-Key": process.env.REACT_APP_API_KEY }),
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to send message");
      }

      // Success
      setStatus({ submitting: false, submitted: true, error: null });
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });

      // Reset success message after 5 seconds
      setTimeout(() => {
        setStatus((prev) => ({ ...prev, submitted: false }));
      }, 5000);
    } catch (error) {
      setStatus({
        submitting: false,
        submitted: false,
        error: error.message,
      });
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <div className="contact-form-wrapper">
          <h2 className="contact-title">{t('contact.title')}</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-field">
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
                <label className="form-label">{t('contact.form.firstName')}</label>
              </div>
              <div className="form-field">
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
                <label className="form-label">{t('contact.form.lastName')}</label>
              </div>
            </div>
            <div className="form-row">
              <div className="form-field">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
                <label className="form-label">{t('contact.form.email')}</label>
              </div>
              <div className="form-field">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="form-input"
                />
                <label className="form-label">{t('contact.form.phone')}</label>
              </div>
            </div>
            <div className="form-field message-field">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className="form-textarea"
                rows="6"
                required
              />
              <label className="form-label">{t('contact.form.message')}</label>
            </div>

            {status.error && (
              <div className="form-error" style={{ color: "red", marginBottom: "15px" }}>
                {status.error}
              </div>
            )}

            {status.submitted && (
              <div className="form-success" style={{ color: "green", marginBottom: "15px" }}>
                {t('contact.form.success')}
              </div>
            )}

            <button
              type="submit"
              className="contact-submit-btn"
              disabled={status.submitting}
            >
              {status.submitting ? t('contact.form.submitting') : t('contact.form.submit')}
            </button>
          </form>
        </div>
        <img
          src={`${MEDIA_URL}/images/about/GET IN TOUCH/Copy of Sophie Stubinski out of the window.webp`}
          alt="Contact us"
          className="contact-image"
        />
      </div>
    </section>
  );
};

export default ContactSection;
